<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="100%"
        >
            <v-card>
                    <v-card-title class="px-3">Merchant Successfully Boarded</v-card-title>
                    <v-divider></v-divider>

                    <v-data-table
                        v-if="report"
                        :headers="headers"
                        :items="report"
                        :items-per-page="10"
                        class="elevation-0 scroll"
                    >
                        <template v-slot:item.channelState="{ item }">

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-if="stateCheck(item)"
                                        x-small
                                        color="success"
                                        v-on="on"
                                    >
                                    mdi-circle
                                    </v-icon>
                                    <v-icon
                                        v-else
                                        x-small
                                        color="error"
                                        v-on="on"
                                    >
                                    mdi-circle
                                    </v-icon>
                                </template>
                                Division: {{ item.divisionState}}<br>
                                Merchant: {{ item.merchantState}}<br>
                                Channel: {{ item.channelState}}
                            </v-tooltip>
                        </template>

                        <template v-slot:item.threeDSecure="{ item }">
                            {{ item.threeDSecure == 1 ? 'Yes' : 'No'  }}
                        </template>
                        <template v-slot:item.subTypes="{ item }">
                            {{ removeDuplicates(item) }}
                        </template>
                    </v-data-table>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="$emit('close', false); success = false;">Close</v-btn>
                    </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        report: Array
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
    },
    data() {
        return {
            headers: [{ text: 'State', value: 'channelState', sortable: false, align: "center" },
                      { text: 'Division', value: 'division', sortable: false },
                      { text: 'Merchant', value: 'merchant', sortable: false },
                      { text: 'Channel', value: 'channel', sortable: false },
                      { text: 'Acquirer', value: 'clearingInstitute', sortable: false },
                      { text: 'Merchant ID', value: 'merchantId', sortable: false, width: 120 },
                    //   { text: 'MCC', value: 'mcc', sortable: false },
                      { text: 'Recurring', value: 'recurringCode', sortable: false },
                      { text: '3D Secure', value: 'threeDSecure', align: 'center', sortable: false, width: 100 },
                    //   { text: 'Visa BIN', value: 'visaBin', sortable: false, align: "left", width: 100 },
                    //   { text: 'Master BIN', value: 'masterBin', sortable: false, align: "left", width: 100 },
                      { text: 'Currencies', value: 'currencies', sortable: false, align: "left" },
                      { text: 'Brands', value: 'subTypes', sortable: false, align: "left" },
                      { text: 'Entity ID', value: 'channelUuid', sortable: false, align: "left" },
                      { text: 'Access Token', value: 'accessToken', sortable: false, align: "left" }]
        }
    },
    methods: {
        stateCheck(item) {
            if(item.divisionState == 'DISABLED') {
                return false;
            }
            else if(item.merchantState == 'DISABLED') {
                return false;
            }
            else if(item.channelState == 'DISABLED') {
                return false;
            }
            else {
                return true;
            }
        },
        removeDuplicates(e) {
            if(e) {
                let brands = e.subTypes.split(',').filter(function(item, pos, self) {
                    return self.indexOf(item) == pos;
                });
                return brands.sort().join();
            }
        }
    }
}
</script>

<style>
    .scroll {
        overflow-y: auto;
        white-space:nowrap;
    }
</style>